import { FC, useEffect, useState } from "react"
import ReactApexChart from "react-apexcharts"
import './proveedoresentradas.css'
import { ProveedoresEntradasKPI } from "./ProveedoresEntradasKPI/ProveedoresEntradasKPI"

export const ProveedoresEntradas:FC<any> = (props):JSX.Element => {

  const { comparativa, stateWarehouseRank, stateNavesRank, stateInventario, kpisEntradas, filtered } = props


  const [estado, setEstado] = useState<any>(stateWarehouseRank)

  const [estado2, setEstado2] = useState<any>(stateNavesRank)

  const [estado3, setEstado3] = useState<any>(stateInventario)

    return (
        <div className="proveedoresentradas__wrapper" style={{overflow:'initial'}}>
            <div className="pentradas-top">
                {
                  estado?.series[0]?.data.length === 0?
                  <div className="donut-internos" style={{display:'flex',justifyContent:'center',alignItems:'center',border:'1px solid lightgray',height:'100%',width:'100%'}}>
                    <span style={{fontFamily:'var(--roboto-light)',width:'60%',textAlign:'center'}}><i>[No existen datos para los filtros aplicados.]</i></span>
                  </div>
                  :
                  <ReactApexChart options={estado?.options} series={estado?.series} type="bar" height={estado.series.length > 0? estado?.series[0].data?.length > 5? estado?.series[0].data?.length * 25 : 200 : 0} />

                }
                
                <div className="pentradas-kpicontainer">
                  {
                    kpisEntradas.map((kpi:any) => {
                      return(
                        <ProveedoresEntradasKPI title={kpi.title} valueA={kpi.valueA} valueB={kpi.valueB} comparativa={comparativa} filtered={filtered} />
                      )
                    })
                  }

                </div>
                {
                  estado2?.series[0]?.data.length === 0?
                  <div className="donut-internos" style={{display:'flex',justifyContent:'center',alignItems:'center',border:'1px solid lightgray',height:'100%',width:'100%'}}>
                    <span style={{fontFamily:'var(--roboto-light)',width:'60%',textAlign:'center'}}><i>[No existen datos para los filtros aplicados.]</i></span>
                  </div>
                  :
                  <ReactApexChart options={estado2?.options} series={estado2?.series} type="bar" height={estado2.series.length > 0? estado2?.series[0].data?.length > 5? estado2?.series[0].data?.length * 40 : 200 : 0} />

                }
                
            </div>
            <div className="chart-of" style={{width:'100%',height:'60%'}}>
                <ReactApexChart options={estado3?.options} series={estado3?.series.map((s:any) => ({...s,data:s.data.map((d:any) => {if(d === 0) {
                    return 0.000001
                }
                return d
                })
                }))} type="bar" height={'100%'} />
            </div>
        </div>
    )
}